import { render } from "./TheoryMediumDevice.vue?vue&type=template&id=4cff4e49&scoped=true"
import script from "./TheoryMediumDevice.vue?vue&type=script&lang=js"
export * from "./TheoryMediumDevice.vue?vue&type=script&lang=js"

import "./TheoryMediumDevice.vue?vue&type=style&index=0&id=4cff4e49&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cff4e49"]])

export default __exports__